import axiosInstance from "./api"
import authHeader from "./auth-header"
import router from "@/router"
import store from "@/store"
import eventBus from '@/plugins/event-bus'

const setup = () => {
    axiosInstance.interceptors.request.use(
        (config) => {
            const xsrfToken = store.state.token.xsrf;
            if(xsrfToken) {
                config.headers = {...config.headers, ...authHeader()};
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    axiosInstance.interceptors.response.use(
        (res) => {
            return res;
        },
        async (err) => {
            const originalConfig = err.config;

            if (originalConfig && originalConfig.url !== "/login" && originalConfig.url !== "/test" && originalConfig.url !== "/login_check" && originalConfig.url !== "/logout" && err.response) {
                // Access Token was expired
                if (originalConfig.url != "/token/refresh" && err.response.status === 401 && !originalConfig._retry) {
                    originalConfig._retry = true;

                    try {
                        await store.dispatch('token/refreshToken')

                        eventBus.emit('refresh-validity-session', store.state.token.validitySessionMinutes)

                        return axiosInstance(originalConfig);
                    } catch (_error) {
                        //if session expired
                        //store.dispatch('auth/logout');
                        //router.push({ name: 'login_account' });

                        return Promise.reject(_error);
                    }
                }
                
                if (err.response.status === 403 && err.response.data && !originalConfig._retry) {
                    originalConfig._retry = true;
                    
                    store.dispatch('auth/logout');
                    router.push({ name: 'login' });

                    return Promise.reject(err.response.data);
                }
            }

            return Promise.reject(err)
        }
    );
};

export default setup;
